import { SxStyleProp } from "theme-ui"

export const root: SxStyleProp = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
}

export const badge: SxStyleProp = {
  mb: [2],
  flexShrink: 0,
  left: "-2px",
  top: "-2px",
  position: "relative",
}

export const description: SxStyleProp = {
  lineHeight: "1.4",
  maxWidth: 256,
  mb: 2,
  color: "textMuted",
  mt: "-2px",
}
